var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1988_12233",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1988_12233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.816 5.35479C23.0071 4.95775 24.3203 5.26776 25.2081 6.15556C26.0959 7.04336 26.4059 8.35656 26.0089 9.54766L25.2487 11.8283C24.4922 14.0977 23.2177 16.1598 21.5262 17.8513L12.1722 27.2053C11.4311 27.9464 10.2294 27.9464 9.4883 27.2053L4.15837 21.8754C3.41722 21.1342 3.41722 19.9326 4.15837 19.1914L13.5124 9.83744C15.2039 8.14592 17.266 6.87146 19.5354 6.11499L21.816 5.35479Z",
    stroke: "#141414",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.8457,
    cy: 12.5191,
    r: 2,
    transform: "rotate(45 18.8457 12.5191)",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.65711 14.0399C4.34932 13.3477 5.33574 13.0367 6.29978 13.2069L8.76852 13.6425L4.23407 18.177L1.87705 15.8199L3.65711 14.0399Z",
    stroke: "#141414",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3269 27.7101C18.0191 27.0179 18.33 26.0315 18.1599 25.0674L17.7242 22.5987L13.1898 27.1331L15.5468 29.4902L17.3269 27.7101Z",
    stroke: "#141414",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8926 16.054L15.3086 17.4701L7.57758 25.2011L6.16154 23.7851L13.8926 16.054Z",
    fill: "#141414"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketBlack);
export default __webpack_public_path__ + "static/media/rocket_black.26e1fdd2775090ac1a8453ff66b02cec.svg";
export { ForwardRef as ReactComponent };